// 应用自动生成图标的共享渲染组件(docs/specs/260728-market-auto-icons)。
// 应用市场(发现/详情/我的已安装)和桌面壳(AppIcon.tsx)共用同一个组件与同一套
// 图标/色板映射,保证同一个应用在市场和桌面上是同一枚图标、同样的圆角与配色。
//
// 图标目录、色板 key 必须和后端 app/services/market_icon_service.py 逐一对应,
// 改这边要同步改后端(或反过来),否则某个 name/background 会退化成兜底图标。
import type { CSSProperties, JSX } from 'react';
import type { ComponentType } from 'react';
import { useState } from 'react';
import type { IconImage, IconTabler } from './manifest';
import {
  IconAbacus,
  IconActivity,
  IconAddressBook,
  IconAdjustments,
  IconAffiliate,
  IconAlarm,
  IconAlertTriangle,
  IconAnalyze,
  IconAnchor,
  IconAntenna,
  IconAntennaBars5,
  IconAperture,
  IconApi,
  IconApps,
  IconArchive,
  IconAtom,
  IconAugmentedReality,
  IconAward,
  IconBarcode,
  IconBarrierBlock,
  IconBasket,
  IconBattery,
  IconBell,
  IconBinary,
  IconBinoculars,
  IconBluetooth,
  IconBolt,
  IconBomb,
  IconBook,
  IconBookmark,
  IconBrackets,
  IconBrain,
  IconBriefcase,
  IconBrowser,
  IconBrush,
  IconBug,
  IconBuilding,
  IconBuildingBank,
  IconBuildingCastle,
  IconBuildingCommunity,
  IconBuildingEstate,
  IconBuildingFactory,
  IconBuildingFortress,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconBuildings,
  IconBulb,
  IconBusinessplan,
  IconCalculator,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarMonth,
  IconCalendarTime,
  IconCamera,
  IconCash,
  IconCashBanknote,
  IconCashRegister,
  IconCertificate,
  IconChartArcs,
  IconChartArea,
  IconChartBar,
  IconChartBubble,
  IconChartCandle,
  IconChartCircles,
  IconChartCohort,
  IconChartColumn,
  IconChartDonut,
  IconChartDots,
  IconChartFunnel,
  IconChartHistogram,
  IconChartInfographic,
  IconChartLine,
  IconChartPie,
  IconChartRadar,
  IconChartSankey,
  IconChartScatter,
  IconChartTreemap,
  IconChecklist,
  IconChess,
  IconChessKnight,
  IconClipboardCheck,
  IconClipboardData,
  IconClipboardList,
  IconClipboardText,
  IconClock,
  IconCloud,
  IconCloudComputing,
  IconCode,
  IconCoffee,
  IconCoin,
  IconCoins,
  IconCommand,
  IconCompass,
  IconContainer,
  IconContract,
  IconCpu,
  IconCreditCard,
  IconCrosshair,
  IconCube,
  IconCurrencyDollar,
  IconDatabase,
  IconDatabaseCog,
  IconDatabaseExport,
  IconDatabaseImport,
  IconDesk,
  IconDeviceCctv,
  IconDeviceDesktop,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTablet,
  IconDeviceTv,
  IconDiscount,
  IconDrone,
  IconDroplet,
  IconEye,
  IconFaceId,
  IconFence,
  IconFileCheck,
  IconFileCode,
  IconFileDiff,
  IconFileInvoice,
  IconFileText,
  IconFilter,
  IconFingerprint,
  IconFlag,
  IconFlag2,
  IconFlask,
  IconFocus2,
  IconFolder,
  IconFolderOpen,
  IconFunction,
  IconGauge,
  IconGhost,
  IconGift,
  IconGiftCard,
  IconGitBranch,
  IconGitCommit,
  IconGitCompare,
  IconGitFork,
  IconGitMerge,
  IconGitPullRequest,
  IconGps,
  IconGridDots,
  IconHeadset,
  IconHelicopter,
  IconHelicopterLanding,
  IconHexagon3d,
  IconHome,
  IconHtml,
  IconIdBadge,
  IconInbox,
  IconJson,
  IconKey,
  IconLanguage,
  IconLayoutGrid,
  IconLayoutKanban,
  IconLayoutList,
  IconLeaf,
  IconLicense,
  IconLink,
  IconListNumbers,
  IconLocation,
  IconLock,
  IconMail,
  IconMailbox,
  IconMap,
  IconMapShield,
  IconMathFunction,
  IconMathSymbols,
  IconMessageChatbot,
  IconMessageCircle,
  IconMessageDots,
  IconMessages,
  IconMicrophone,
  IconMicroscope,
  IconMilitaryAward,
  IconMilitaryRank,
  IconMoneybag,
  IconMoon,
  IconMovie,
  IconMusic,
  IconNetwork,
  IconNote,
  IconNotebook,
  IconNotes,
  IconPackage,
  IconPalette,
  IconPaperclip,
  IconParachute,
  IconPercentage,
  IconPhone,
  IconPhoto,
  IconPlane,
  IconPlanet,
  IconPlug,
  IconPremiumRights,
  IconPresentation,
  IconPresentationAnalytics,
  IconPrinter,
  IconPuzzle,
  IconQrcode,
  IconRadar,
  IconRadar2,
  IconRadio,
  IconReceipt,
  IconRecycle,
  IconRegex,
  IconReport,
  IconReportAnalytics,
  IconReportMoney,
  IconRobot,
  IconRobotFace,
  IconRocket,
  IconRoute,
  IconRouteScan,
  IconRouter,
  IconRss,
  IconSatellite,
  IconScale,
  IconScan,
  IconScanEye,
  IconSearch,
  IconSend,
  IconServer,
  IconServerBolt,
  IconServerCog,
  IconSettings,
  IconShare,
  IconShield,
  IconShieldCheckered,
  IconShieldLock,
  IconShip,
  IconShoppingBag,
  IconShoppingCart,
  IconSignature,
  IconSitemap,
  IconSourceCode,
  IconSparkles,
  IconSpeakerphone,
  IconSql,
  IconStack,
  IconStairs,
  IconSubmarine,
  IconSum,
  IconSun,
  IconTable,
  IconTableExport,
  IconTank,
  IconTarget,
  IconTargetArrow,
  IconTax,
  IconTemperature,
  IconTemplate,
  IconTerminal,
  IconTerminal2,
  IconTestPipe,
  IconTimeline,
  IconTool,
  IconTopologyStar,
  IconTrendingDown,
  IconTrendingUp,
  IconTrophy,
  IconTruck,
  IconTypography,
  IconUmbrella,
  IconUsers,
  IconUsersGroup,
  IconVariable,
  IconVectorTriangle,
  IconVersions,
  IconVideo,
  IconVocabulary,
  IconVolume,
  IconWallet,
  IconWand,
  IconWaveSine,
  IconWebhook,
  IconWifi,
  IconWorld,
  IconWorldPin,
  IconWorldWww,
} from '@tabler/icons-react';

type TablerIconComponent = ComponentType<{
  size?: number | string;
  color?: string;
  stroke?: number | string;
  style?: CSSProperties;
}>;

// 受控图标目录:分类 → kebab-case key(对应后端 market_icon_service.ICON_POOLS
// 同一个分类同一个 key)→ 显式导入的 Tabler 组件。禁止按 name 字符串动态
// import——目录固定、可枚举。这是本文件的唯一事实源:扁平的 ICON_MAP(渲染用)
// 和按分类分组的 ICON_CATEGORIES(图标库选择器分类 tab 用)都从这里派生,不
// 手动维护第二份、第三份名单,不会互相漂移。分类顺序/名称必须和后端一一对应。
const ICON_POOL_ENTRIES: Record<string, Record<string, TablerIconComponent>> = {
  办公效率: {
    calendar: IconCalendar,
    'clipboard-check': IconClipboardCheck,
    'file-text': IconFileText,
    mail: IconMail,
    users: IconUsers,
    plane: IconPlane,
    clock: IconClock,
    'calendar-event': IconCalendarEvent,
    checklist: IconChecklist,
    notebook: IconNotebook,
    printer: IconPrinter,
    phone: IconPhone,
    video: IconVideo,
    presentation: IconPresentation,
    bell: IconBell,
    bookmark: IconBookmark,
    archive: IconArchive,
    inbox: IconInbox,
    send: IconSend,
    certificate: IconCertificate,
    alarm: IconAlarm,
    'calendar-month': IconCalendarMonth,
    'calendar-time': IconCalendarTime,
    'id-badge': IconIdBadge,
    signature: IconSignature,
    paperclip: IconPaperclip,
    mailbox: IconMailbox,
    note: IconNote,
    notes: IconNotes,
    timeline: IconTimeline,
    speakerphone: IconSpeakerphone,
    coffee: IconCoffee,
    desk: IconDesk,
    contract: IconContract,
    'address-book': IconAddressBook,
    'clipboard-list': IconClipboardList,
    'clipboard-text': IconClipboardText,
    headset: IconHeadset,
    'device-desktop': IconDeviceDesktop,
    qrcode: IconQrcode,
    'file-check': IconFileCheck,
    'layout-kanban': IconLayoutKanban,
    'layout-list': IconLayoutList,
    adjustments: IconAdjustments,
    volume: IconVolume,
    'folder-open': IconFolderOpen,
    'clipboard-data': IconClipboardData,
  },
  业务系统: {
    briefcase: IconBriefcase,
    building: IconBuilding,
    'shopping-cart': IconShoppingCart,
    wallet: IconWallet,
    package: IconPackage,
    receipt: IconReceipt,
    'credit-card': IconCreditCard,
    coin: IconCoin,
    cash: IconCash,
    'file-invoice': IconFileInvoice,
    truck: IconTruck,
    'building-store': IconBuildingStore,
    'building-bank': IconBuildingBank,
    'users-group': IconUsersGroup,
    scale: IconScale,
    target: IconTarget,
    'report-money': IconReportMoney,
    'shopping-bag': IconShoppingBag,
    basket: IconBasket,
    'building-warehouse': IconBuildingWarehouse,
    'building-factory': IconBuildingFactory,
    'building-skyscraper': IconBuildingSkyscraper,
    buildings: IconBuildings,
    'cash-banknote': IconCashBanknote,
    'cash-register': IconCashRegister,
    discount: IconDiscount,
    'currency-dollar': IconCurrencyDollar,
    percentage: IconPercentage,
    award: IconAward,
    trophy: IconTrophy,
    gift: IconGift,
    businessplan: IconBusinessplan,
    moneybag: IconMoneybag,
    coins: IconCoins,
    tax: IconTax,
    'building-community': IconBuildingCommunity,
    'building-estate': IconBuildingEstate,
    'premium-rights': IconPremiumRights,
    'gift-card': IconGiftCard,
    stairs: IconStairs,
    license: IconLicense,
    umbrella: IconUmbrella,
  },
  数据看板: {
    'chart-bar': IconChartBar,
    'chart-pie': IconChartPie,
    database: IconDatabase,
    table: IconTable,
    'trending-up': IconTrendingUp,
    'chart-line': IconChartLine,
    'chart-dots': IconChartDots,
    'chart-area': IconChartArea,
    'chart-histogram': IconChartHistogram,
    report: IconReport,
    'list-numbers': IconListNumbers,
    filter: IconFilter,
    gauge: IconGauge,
    'chart-candle': IconChartCandle,
    sum: IconSum,
    'chart-donut': IconChartDonut,
    activity: IconActivity,
    analyze: IconAnalyze,
    'chart-arcs': IconChartArcs,
    'chart-bubble': IconChartBubble,
    'chart-scatter': IconChartScatter,
    'chart-radar': IconChartRadar,
    'chart-funnel': IconChartFunnel,
    'chart-treemap': IconChartTreemap,
    'chart-sankey': IconChartSankey,
    'chart-infographic': IconChartInfographic,
    'report-analytics': IconReportAnalytics,
    'presentation-analytics': IconPresentationAnalytics,
    'chart-column': IconChartColumn,
    'trending-down': IconTrendingDown,
    'chart-cohort': IconChartCohort,
    'chart-circles': IconChartCircles,
    'database-export': IconDatabaseExport,
    'database-import': IconDatabaseImport,
    affiliate: IconAffiliate,
    'table-export': IconTableExport,
  },
  智能体应用: {
    robot: IconRobot,
    sparkles: IconSparkles,
    'message-circle': IconMessageCircle,
    network: IconNetwork,
    brain: IconBrain,
    bulb: IconBulb,
    wand: IconWand,
    ghost: IconGhost,
    'message-chatbot': IconMessageChatbot,
    atom: IconAtom,
    cpu: IconCpu,
    eye: IconEye,
    microphone: IconMicrophone,
    messages: IconMessages,
    rocket: IconRocket,
    bolt: IconBolt,
    fingerprint: IconFingerprint,
    'face-id': IconFaceId,
    language: IconLanguage,
    scan: IconScan,
    'scan-eye': IconScanEye,
    'augmented-reality': IconAugmentedReality,
    vocabulary: IconVocabulary,
    'robot-face': IconRobotFace,
    'message-dots': IconMessageDots,
    aperture: IconAperture,
    'hexagon-3d': IconHexagon3d,
    chess: IconChess,
    'chess-knight': IconChessKnight,
    'wave-sine': IconWaveSine,
    flask: IconFlask,
    'test-pipe': IconTestPipe,
    microscope: IconMicroscope,
    planet: IconPlanet,
    'math-function': IconMathFunction,
    calculator: IconCalculator,
    function: IconFunction,
    abacus: IconAbacus,
    variable: IconVariable,
    'vector-triangle': IconVectorTriangle,
    'math-symbols': IconMathSymbols,
  },
  开发工具: {
    code: IconCode,
    terminal: IconTerminal,
    'git-branch': IconGitBranch,
    server: IconServer,
    cloud: IconCloud,
    settings: IconSettings,
    bug: IconBug,
    'git-commit': IconGitCommit,
    'git-merge': IconGitMerge,
    'git-pull-request': IconGitPullRequest,
    api: IconApi,
    webhook: IconWebhook,
    key: IconKey,
    lock: IconLock,
    binary: IconBinary,
    tool: IconTool,
    'terminal-2': IconTerminal2,
    sql: IconSql,
    json: IconJson,
    html: IconHtml,
    brackets: IconBrackets,
    regex: IconRegex,
    command: IconCommand,
    container: IconContainer,
    'cloud-computing': IconCloudComputing,
    'source-code': IconSourceCode,
    versions: IconVersions,
    'server-bolt': IconServerBolt,
    'server-cog': IconServerCog,
    'world-www': IconWorldWww,
    'topology-star': IconTopologyStar,
    'device-laptop': IconDeviceLaptop,
    template: IconTemplate,
    sitemap: IconSitemap,
    'git-fork': IconGitFork,
    'file-diff': IconFileDiff,
    router: IconRouter,
    stack: IconStack,
    'file-code': IconFileCode,
    'database-cog': IconDatabaseCog,
    'git-compare': IconGitCompare,
  },
  其他: {
    apps: IconApps,
    'grid-dots': IconGridDots,
    folder: IconFolder,
    search: IconSearch,
    shield: IconShield,
    puzzle: IconPuzzle,
    home: IconHome,
    flag: IconFlag,
    map: IconMap,
    compass: IconCompass,
    camera: IconCamera,
    palette: IconPalette,
    music: IconMusic,
    book: IconBook,
    world: IconWorld,
    'layout-grid': IconLayoutGrid,
    cube: IconCube,
    share: IconShare,
    link: IconLink,
    wifi: IconWifi,
    bluetooth: IconBluetooth,
    battery: IconBattery,
    plug: IconPlug,
    barcode: IconBarcode,
    radio: IconRadio,
    rss: IconRss,
    location: IconLocation,
    gps: IconGps,
    route: IconRoute,
    'device-mobile': IconDeviceMobile,
    'device-tablet': IconDeviceTablet,
    photo: IconPhoto,
    movie: IconMovie,
    brush: IconBrush,
    'device-tv': IconDeviceTv,
    browser: IconBrowser,
    typography: IconTypography,
    recycle: IconRecycle,
    leaf: IconLeaf,
    droplet: IconDroplet,
    sun: IconSun,
    moon: IconMoon,
    temperature: IconTemperature,
  },
  军事: {
    ship: IconShip,
    submarine: IconSubmarine,
    tank: IconTank,
    radar: IconRadar,
    'radar-2': IconRadar2,
    drone: IconDrone,
    anchor: IconAnchor,
    binoculars: IconBinoculars,
    crosshair: IconCrosshair,
    satellite: IconSatellite,
    helicopter: IconHelicopter,
    parachute: IconParachute,
    'military-award': IconMilitaryAward,
    'military-rank': IconMilitaryRank,
    'target-arrow': IconTargetArrow,
    antenna: IconAntenna,
    bomb: IconBomb,
    'shield-checkered': IconShieldCheckered,
    'flag-2': IconFlag2,
    'building-fortress': IconBuildingFortress,
    'building-castle': IconBuildingCastle,
    fence: IconFence,
    'barrier-block': IconBarrierBlock,
    'map-shield': IconMapShield,
    'antenna-bars-5': IconAntennaBars5,
    'shield-lock': IconShieldLock,
    'helicopter-landing': IconHelicopterLanding,
    'route-scan': IconRouteScan,
    'focus-2': IconFocus2,
    'device-cctv': IconDeviceCctv,
    'alert-triangle': IconAlertTriangle,
    'world-pin': IconWorldPin,
  },
};

// 扁平映射:渲染(MarketAppIcon / getMarketIconGlyph)不关心分类,只要 name→组件。
const ICON_MAP: Record<string, TablerIconComponent> = Object.assign(
  {},
  ...Object.values(ICON_POOL_ENTRIES),
);

// 分类 → 该分类下的 icon name 列表(图标库选择器按分类分组展示用,不再是一次性
// 铺开的三百格大网格)。顺序即后端 ICON_POOLS 的分类顺序,选择器默认选中第一个。
export const ICON_CATEGORIES: Record<string, string[]> = Object.fromEntries(
  Object.entries(ICON_POOL_ENTRIES).map(([category, icons]) => [category, Object.keys(icons)]),
);

// 受控色板(对应后端 market_icon_service.BACKGROUNDS)。渐变 135deg,和 OS
// 其余圆角方块图标(CategoryIcon.tsx / AppIcon.tsx)风格保持一致。
export const TABLER_BACKGROUNDS: Record<string, string> = {
  ocean: 'linear-gradient(135deg,#0ea5e9,#2563eb)',
  sunset: 'linear-gradient(135deg,#fb923c,#ea580c)',
  violet: 'linear-gradient(135deg,#a78bfa,#7c3aed)',
  forest: 'linear-gradient(135deg,#34d399,#059669)',
  rose: 'linear-gradient(135deg,#fb7185,#e11d48)',
  amber: 'linear-gradient(135deg,#fbbf24,#d97706)',
  slate: 'linear-gradient(135deg,#94a3b8,#475569)',
  teal: 'linear-gradient(135deg,#2dd4bf,#0d9488)',
  indigo: 'linear-gradient(135deg,#818cf8,#4338ca)',
  crimson: 'linear-gradient(135deg,#f472b6,#be123c)',
};

const DEFAULT_BACKGROUND = 'linear-gradient(135deg,#94a3b8,#64748b)';

/** 取某个图标名对应的裸 Tabler 组件(未知名字退化成中性 apps 图标)——用于精选卡
 * 这类需要把"同一枚图标"放大做背景装饰、而不是重新画一个小方块 tile 的场景。 */
export function getMarketIconGlyph(name: string | undefined): TablerIconComponent {
  return (name && ICON_MAP[name]) || IconApps;
}

// 受控图标目录的全部合法 name(对应后端 market_icon_service.ALL_ICON_NAMES)。
// 图标库选择器(service-manager 的「登记服务」表单)据此渲染候选网格,不用
// 手动维护第二份名单。
export const ALL_ICON_NAMES: string[] = Object.keys(ICON_MAP);

export type MarketIconSource = IconTabler | IconImage;

/** 装饰层(variant):很轻的固定变体,不影响小尺寸清晰度。0=无装饰。 */
function Decoration({ variant, size }: { variant: number; size: number }): JSX.Element | null {
  switch (variant) {
    case 1:
      // 光晕:右上角一团柔光。
      return (
        <span
          aria-hidden
          style={{
            position: 'absolute', width: size * 0.7, height: size * 0.7, top: -size * 0.2, right: -size * 0.2,
            borderRadius: '50%', background: 'rgba(255,255,255,.28)', filter: `blur(${size * 0.12}px)`,
          }}
        />
      );
    case 2:
      // 网点:几个淡白色小圆点,散落左下。
      return (
        <svg aria-hidden width={size} height={size} viewBox="0 0 24 24" style={{ position: 'absolute', inset: 0, opacity: 0.35 }}>
          <circle cx="4" cy="19" r="1.1" fill="#fff" />
          <circle cx="7.5" cy="20.5" r="0.8" fill="#fff" />
          <circle cx="3" cy="15.5" r="0.7" fill="#fff" />
        </svg>
      );
    case 3:
      // 高光:左上角一条柔和斜向高光带。
      return (
        <span
          aria-hidden
          style={{
            position: 'absolute', inset: 0, borderRadius: 'inherit',
            background: 'linear-gradient(135deg,rgba(255,255,255,.32) 0%,rgba(255,255,255,0) 45%)',
          }}
        />
      );
    default:
      return null;
  }
}

/**
 * 圆角方块 tile,渲染自动生成 / 库选的应用图标,或上传的自定义图标图片。
 * 未知 / 缺失的 icon 数据(遗留脏数据、网络尚未加载完成、图片加载失败)退化
 * 成中性兜底图标,不报错、不显示一个字或 emoji。
 */
export function MarketAppIcon({
  icon,
  size = 56,
  style,
}: {
  icon: MarketIconSource | null | undefined;
  size?: number;
  style?: CSSProperties;
}) {
  if (icon && icon.type === 'image') {
    return <MarketImageIcon url={icon.url} size={size} style={style} />;
  }
  const tabler = icon && icon.type === 'tabler' ? icon : null;
  const Glyph = (tabler && ICON_MAP[tabler.name]) || IconApps;
  const background = (tabler && TABLER_BACKGROUNDS[tabler.background]) || DEFAULT_BACKGROUND;
  const variant = tabler?.variant ?? 0;
  const inner = Math.round(size * 0.54);
  return (
    <span
      style={{
        width: size, height: size, borderRadius: size >= 48 ? 14 : 10, flex: 'none', position: 'relative',
        display: 'flex', alignItems: 'center', justifyContent: 'center', background,
        boxShadow: '0 8px 20px rgba(15,23,42,.22), inset 0 1px 0 rgba(255,255,255,.3)', overflow: 'hidden',
        ...style,
      }}
    >
      <Decoration variant={variant} size={size} />
      <Glyph size={inner} color="#fff" stroke={1.9} style={{ position: 'relative' }} />
    </span>
  );
}

/** 自定义上传图标(image 类型):同尺寸 tile,<img> 铺满并裁切;加载失败退化
 * 成跟 tabler 兜底一致的中性 apps 玻璃方块,不留破图标。 */
function MarketImageIcon({
  url,
  size,
  style,
}: {
  url: string;
  size: number;
  style?: CSSProperties;
}) {
  const [failed, setFailed] = useState(false);
  const radius = size >= 48 ? 14 : 10;
  if (failed) {
    return (
      <span
        style={{
          width: size, height: size, borderRadius: radius, flex: 'none', position: 'relative',
          display: 'flex', alignItems: 'center', justifyContent: 'center', background: DEFAULT_BACKGROUND,
          boxShadow: '0 8px 20px rgba(15,23,42,.22), inset 0 1px 0 rgba(255,255,255,.3)', overflow: 'hidden',
          ...style,
        }}
      >
        <IconApps size={Math.round(size * 0.54)} color="#fff" stroke={1.9} />
      </span>
    );
  }
  return (
    <span
      style={{
        width: size, height: size, borderRadius: radius, flex: 'none', position: 'relative',
        display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
        boxShadow: '0 8px 20px rgba(15,23,42,.22)',
        ...style,
      }}
    >
      <img
        src={url}
        alt=""
        aria-hidden
        onError={() => setFailed(true)}
        style={{ width: size, height: size, objectFit: 'cover', display: 'block' }}
      />
    </span>
  );
}
